import { h, Component } from "preact";
import { connect } from "preact-redux";
import style from "./style.scss";
import {
  TicketModel,
  SystemModel,
  CustomizationModel,
  UserModel,
  CompanyModel,
} from "/chat/src/redux/model";
// this is a copy from StartChatting Button

class StartChattingButton extends Component {
  constructor(props) {
    super(props);
    this.handleStartChatClick = this.handleStartChatClick.bind(this);
  }

  handleStartChatClick() {
    if (this.props.disabled) return; // if disabled do not answer
    this.props.dispatch(UserModel.requestSetUserAcceptedGDPR());
    if (this.props.formsRequire || this.props.isOffline) {
      this.props.dispatch(SystemModel.setRoute("StartChatting"));
    } else if (this.props.conversations.isEmpty()) {
      this.props.dispatch(SystemModel.setRoute("Chat"));
    } else {
      this.props.dispatch(SystemModel.setRoute("Conversations"));
    }
  }

  render() {
    //20px for Powered by Jibber label
    const bodyHeight = this.props.height - 35;
    const bodyHeightPx = bodyHeight + "px";
    const bodyWidth = this.props.width;
    const language = this.props.language;

    let text = language.get("StartChatting");

    var size = bodyHeight > bodyWidth ? bodyWidth / 2 : bodyHeight / 2;
    size += 30;
    let height = size;
    let width = size;
    var borderRadius = size;
    let heightPx = height - 40 + "px";
    let widthPx = width - 40 + "px";
    let marginTop = bodyHeight / 2 - size / 2 + 20 + "px";
    let fontSize = "20px";
    let hoverStyle = " hvr-grow";
    if (bodyHeight < 260) {
      heightPx = "55px";
      widthPx = "50%";
      borderRadius = "60px";
      marginTop = height / 2 + "px";
      hoverStyle = " ";
    }
    return (
      <div
        className={style.StartChattingButtonWrapper}
        style={{ height: bodyHeightPx }}
      >
        <div
          className={style.StartChattingButton + hoverStyle}
          onClick={this.handleStartChatClick}
          style={{
            cursor: this.props.disabled ? "not-allowed" : "pointer",
            opacity: this.props.disabled ? 0.3 : 1,
            marginTop: marginTop,
            backgroundColor: this.props.color,
            width: widthPx,
            height: heightPx,
            lineHeight: heightPx,
            borderRadius: borderRadius,
            fontSize: fontSize,
          }}
        >
          <span className={style.StartChattingText}> {text} </span>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const color = CustomizationModel.getColor(state);
  const language = CustomizationModel.getLanguage(state);
  const conversations = TicketModel.getAll(state);
  return {
    height: SystemModel.getBodyHeight(state),
    width: SystemModel.getShellWidth(state),
    user: UserModel.get(state).toJS(),
    conversations,
    color,
    language,
    // need this for the default case, this will just imitate the default button click as if there was no gdpr form, check if case in button click
    formsRequire: CustomizationModel.getFormsRequire(state),
    isOffline: CompanyModel.isOffline(state),
  };
}

export default connect(mapStateToProps)(StartChattingButton);



// WEBPACK FOOTER //
// ./routes/GDPROverlay/Button.js